import React from "react";
import { Modal } from "semantic-ui-react";
import styles from "./ModalPopup.module.scss";
import { connect } from "react-redux";
import { closeModal } from "../../actions/siteActions";
import { PopupInner } from "../../types/siteTypes";
import Login from "./Login";
import Register from "../../screens/Register";
import ForgetPassword from "../ForgetPassword";
import { popupInnerSelector, popupOpenSelector } from "../../utils/selectors";

const ModalPopup: React.FC<any> = ({ popupOpen, closeModal, popupInner }) => {
  const getPopupInnerContent = () => {
    switch (popupInner) {
      case PopupInner.LogIn:
        return <Login />;
      case PopupInner.Register:
        return <Register />;
      case PopupInner.ForgottenPassword:
        return <ForgetPassword />;
      default:
        return <Login />;
    }
  };
  return (
    <Modal
      open={popupOpen}
      closeIcon={{
        style: { top: "16px", right: "16px" },
        color: "black",
        name: "close",
      }}
      onClose={() => closeModal(false)}
      size={"tiny"}
      dimmer={"inverted"}
      className={styles.modal}
    >
      <Modal.Content>{getPopupInnerContent()}</Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  popupOpen: popupOpenSelector(state),
  popupInner: popupInnerSelector(state),
});
const mapDispatchToProps = (dispatch: any) => ({
  closeModal: () => dispatch(closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalPopup);
